module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"col-sm-1 nopadding asset factory-widget asset-has-menu\"  draggable=\"true\" id=\"")
    ; __append(escapeFn( assetId  ))
    ; __append("\" data-asset-id=\"")
    ; __append(escapeFn( assetId  ))
    ; __append("\" data-control-type=\"")
    ; __append(escapeFn( controlType  ))
    ; __append("\" data-animation=\"true\"\r\n     data-toggle=\"tooltip\" title data-original-title=\"")
    ; __append(escapeFn( tmpName ))
    ; __append("\" data-placement=\"right\">\r\n    <div class=\"asset-selected\"> \r\n        <div class=\"thumb ui-widget-header\" style=\" width: 88px; height: 53px;\"> \r\n            <i class=\"fa pf-picture\"></i>\r\n            <p class =\"trim-text label-asset-name\" data-asset-id=\"")
    ; __append(escapeFn( assetId  ))
    ; __append("\" id=\"asset-label-")
    ; __append(escapeFn( id))
    ; __append("\">")
    ; __append(escapeFn( tmpName ))
    ; __append("</p>\r\n            <input type=\"text\" id=\"asset-edit-")
    ; __append(escapeFn( id))
    ; __append("\" data-asset-id=\"")
    ; __append(escapeFn( assetId  ))
    ; __append("\" class=\"edit-asset-name\" value=\"")
    ; __append(escapeFn( tmpName ))
    ; __append("\" style=\"height: 20px; display: none; margin-top: -4px;\">\r\n        </div> \r\n    </div>    \r\n</div>\r\n")
  }
  return __output;

}